/** Dispatched when tag dimensions or tags change so editors (e.g. FeaturePanel) can refresh. */

export const DIMENSION_TAG_LIST_CHANGED = 'featureview:dimensionOrTagListChanged';

export function notifyDimensionOrTagListChanged(featureGroupId) {
  if (typeof window === 'undefined' || !featureGroupId) return;
  window.dispatchEvent(
    new CustomEvent(DIMENSION_TAG_LIST_CHANGED, {
      detail: { featureGroupId }
    })
  );
}
